module.exports = __webpack_public_path__ + "img/raporty.8595eaae.svg";